import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { serverLink } from "../../../resources/url";
import { toast } from "react-toastify";
import { showAlert } from "../../common/sweetalert/sweetalert";
import DataLoader from "../../common/dataLoader/dataLoader";
import DataTable from "../../common/data-table/data-table";
import { formatDateAndTime } from "../../../resources/constants";

function JambRegularizationReport(props) {
    const [IsLoading, setIsLoading] = useState(true);
    const [IsActionLoading, setIsActionLoading] = useState(false);
    const [recordList, setRecordList] = useState([]);
    const header = [
        "S/N", "AppID", "StudentID", "JAMB Reg No", "Surname", "First Name",
        "Middle Name", "Phone", "Email", "Programme Code",
        "Status", "Inserted By", "Date", "Action",
    ];

    useEffect(() => {
        getData();
    }, [""]);

    const getData = async () => {
        await axios
            .get(`${serverLink}staff/registration/registration/student/jamb-regularization`)
            .then((result) => {
                setRecordList(result.data);
                setIsLoading(false);
            })
            .catch(() => {
                console.log("NETWORK ERROR");
                setIsLoading(false);
            });
    };

    const markCompleted = async (AppID) => {
        setIsActionLoading(true);
        await axios
            .patch(`${serverLink}staff/registration/registration/student/jamb-regularization/complete`, {
                AppID,
                UpdatedBy: props.loginData[0]?.StaffID,
            })
            .then((result) => {
                if (result.data.message === "success") {
                    toast.success("Status updated to Completed successfully");
                    getData();
                } else {
                    showAlert("ERROR", "Something went wrong. Please try again!", "error");
                }
                setIsActionLoading(false);
            })
            .catch(() => {
                setIsActionLoading(false);
                showAlert("NETWORK ERROR", "Please check your connection and try again!", "error");
            });
    };

    const showTable = () => {
        try {
            return recordList.map((item, index) => {
                const isCompleted = item.Status === "Completed";
                const statusClass = isCompleted ? "text-success" : "text-warning";
                return (
                    <tr key={index}>
                        <td className="text-xs font-weight-bold">{index + 1}</td>
                        <td className="text-xs font-weight-bold">{item.AppID}</td>
                        <td className="text-xs font-weight-bold">{item.StudentID}</td>
                        <td className="text-xs font-weight-bold">{item.JambRegNo}</td>
                        <td className="text-xs font-weight-bold">{item.Surname}</td>
                        <td className="text-xs font-weight-bold">{item.FirstName}</td>
                        <td className="text-xs font-weight-bold">{item.MiddleName}</td>
                        <td className="text-xs font-weight-bold">{item.Phone}</td>
                        <td className="text-xs font-weight-bold">{item.Email}</td>
                        <td className="text-xs font-weight-bold">{item.ProgrammeName}</td>
                        {/* <td className="text-xs font-weight-bold">{item.YearOfAdmission}</td> */}
                        <td className={`text-xs font-weight-bold ${statusClass}`}>{item.Status}</td>
                        <td className="text-xs font-weight-bold">{item.InsertedBy}</td>
                        <td className="text-xs font-weight-bold">
                            {item.InsertedDate ? formatDateAndTime(item.InsertedDate, "date") : "N/A"}
                        </td>
                        <td className="text-xs font-weight-bold">
                            {isCompleted ? (
                                <span className="badge bg-success">Completed</span>
                            ) : (
                                <button
                                    className="btn btn-success btn-sm"
                                    disabled={IsActionLoading}
                                    onClick={() => markCompleted(item.AppID)}
                                >
                                    Mark as Completed
                                </button>
                            )}
                        </td>
                    </tr>
                );
            });
        } catch (e) {
            alert(e.message);
        }
    };

    return IsLoading ? (
        <div className="container-xl" style={{ height: "700px" }}>
            <div className="page-header d-print-none">
                <DataLoader />
            </div>
        </div>
    ) : (
        <>
            <div className="container-xl">
                <div className="page-header d-print-none">
                    <div className="row align-items-center">
                        <div className="col">
                            <div className="page-pretitle"></div>
                            <h2 className="page-title">JAMB Regularization Processing Report</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-body">
                <div className="container-xl">
                    <div className="row row-deck row-cards">
                        <div className="col-lg-12">
                            <div className="row row-cards">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h3 className="card-title">JAMB Regularization Processing Report</h3>
                                            <DataTable
                                                header={header}
                                                body={showTable()}
                                                title="JAMB Regularization Processing Report"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        loginData: state.loginDetails,
    };
};

export default connect(mapStateToProps, null)(JambRegularizationReport);
